import { Helmet } from "react-helmet"
import React from "react"

export const CustomMetadata = () => <Helmet>
  {/* User metadata would be injected here
It's done by overriding this file with a template
& combining it with user input*/}
</Helmet>
